module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de_at":{"sign in":"Anmelden","sign up":"Registrieren"},"cs":{"sign in":"přihlásit se","sign up":"Registrovat"},"hu":{"sign in":"Bejelentkezés","sign up":"regisztrálj"},"fr":{"sign in":"se connecter","sign up":"s\u0027inscrire"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/frontend/menu/Navbar.vue
// module id = 1143
// module chunks = 0